import React from 'react';

function Footer() {
    return (
        <footer className="text-sm mt-auto py-6 transition-colors duration-300 w-full">
            <div className="max-w-7xl w-[90%] mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div className="footer-copyright">
                        © 2013 - {new Date().getFullYear()} Davooda. All rights reserved.
                    </div>
                    <div className="flex gap-6">
                        <a href="/terms" className="text-black hover:underline transition-colors duration-300">Terms of Use</a>
                        <a href="/privacy" className="text-black hover:underline transition-colors duration-300">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
